import { render, staticRenderFns } from "./GavelEndCircle.vue?vue&type=template&id=66517362"
import script from "./GavelEndCircle.vue?vue&type=script&lang=ts"
export * from "./GavelEndCircle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports